import { createSelector } from '@reduxjs/toolkit';
import { EditIcon } from 'evergreen-ui';
import { dcpcApi } from './dcpcApi';

const STATION_TYPES_TAG = 'StationTypes';

dcpcApi.enhanceEndpoints({ addTagTypes: [STATION_TYPES_TAG] });
const stationTypesApi = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    getStationTypes: builder.query({
      query: () => ({
        url: 'stationtypes',
        method: 'get',
      }),
      providesTags: [STATION_TYPES_TAG],
    }),

    getStationType: builder.query({
      query: (id) => `stationtype/${id}`,
      providesTags: [STATION_TYPES_TAG],
    }),

    updateStationTypes: builder.mutation({
      query: (args) => ({
        method: args.id ? 'PUT' : 'POST',
        url: `stationtype/${args.id || ''}`,
        body: args,
      }),
      invalidatesTags: [STATION_TYPES_TAG],
    }),
  }),
});

export const {
  useGetStationTypesQuery,
  useGetStationTypeQuery,
  useUpdateStationTypesMutation,
} = stationTypesApi;

export const stationTypesSelect = (state) => stationTypesApi.endpoints.getStationTypes.select()(state);
export const stationTypesSelector = (state) => stationTypesSelect(state).data || [];

const filterStationTypesBySearchTextSelector = createSelector(
  stationTypesSelector,
  (_, searchText) => searchText,
  (stationTypes, searchText) => ({
    columns: [
      {
        label: 'Название типа станции',
      },
      {
        label: 'Название категории станции',
      },
    ],
    rows: stationTypes.reduce((acc, cur) => {
      const { id, name, vocStationCat } = cur;
      const { name: stationTypeCatName } = vocStationCat || {};
      const row = [id, name, stationTypeCatName || ''];
      if (row.filter((v, idx) => idx !== 0 && v !== null && v.toUpperCase().includes(searchText.toUpperCase())).length > 0) {
        acc.push(row);
      }
      return acc;
    }, []),
    rowButtons: [
      {
        label: 'Редактировать',
        to: (id) => `${id}`, // переход на форму редактирования
        icon: EditIcon,
      },
    ],
    createLink: {
      label: 'Создать тип станции',
    },
  }),
);
export const stationTypesBySearchTextSelector = (searchText) => (state) => filterStationTypesBySearchTextSelector(state, searchText);

const stationTypesByStationCatId = createSelector(
  stationTypesSelector,
  (_, stationCatId) => stationCatId,
  (stationTypes, stationCatId) => {
    if (stationCatId !== undefined) {
      return stationTypes.filter(({ vocStationCat }) => vocStationCat.id === stationCatId);
    }
    return stationTypes;
  },
);
export const stationTypesByStationCatIdSelector = (id) => (state) => stationTypesByStationCatId(state, id);
